module.exports = __webpack_public_path__ + "static/media/box-small-employee_748x748.17bb9015.jpg";